var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBank(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.83325 7.85502C1.83325 6.75852 2.27543 6.08654 3.1905 5.5773L6.9573 3.48103C8.93109 2.38259 9.91798 1.83337 10.9999 1.83337C12.0819 1.83337 13.0687 2.38259 15.0425 3.48103L18.8094 5.5773C19.7244 6.08654 20.1666 6.75853 20.1666 7.85502C20.1666 8.15235 20.1666 8.30102 20.1341 8.42324C19.9635 9.06537 19.3816 9.16671 18.8197 9.16671H3.18009C2.61817 9.16671 2.03631 9.06536 1.86572 8.42324C1.83325 8.30102 1.83325 8.15235 1.83325 7.85502Z",
    stroke: "#423F5A",
    strokeWidth: 1.375
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9963 6.41663H11.0053",
    stroke: "#423F5A",
    strokeWidth: 1.83333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.66675 9.16663V16.9583M7.33341 9.16663V16.9583",
    stroke: "#423F5A",
    strokeWidth: 1.375
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6667 9.16663V16.9583M18.3334 9.16663V16.9583",
    stroke: "#423F5A",
    strokeWidth: 1.375
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4166 16.9584H4.58325C3.06447 16.9584 1.83325 18.1895 1.83325 19.7084C1.83325 19.9615 2.03846 20.1667 2.29159 20.1667H19.7083C19.9613 20.1667 20.1666 19.9615 20.1666 19.7084C20.1666 18.1895 18.9354 16.9584 17.4166 16.9584Z",
    stroke: "#423F5A",
    strokeWidth: 1.375
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBank);
export default __webpack_public_path__ + "static/media/bank.9b277793547935d7aa171f79b63bf5e2.svg";
export { ForwardRef as ReactComponent };